module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/grad-05-de66bd195f8e16eee580ae0d6271566b.webp";